__turbopack_context__.v({
  "body": "drawer-module-scss-module__nzOrvG__body",
  "close": "drawer-module-scss-module__nzOrvG__close",
  "column": "drawer-module-scss-module__nzOrvG__column",
  "content": "drawer-module-scss-module__nzOrvG__content",
  "drawerContent": "drawer-module-scss-module__nzOrvG__drawerContent",
  "drawerWindow": "drawer-module-scss-module__nzOrvG__drawerWindow",
  "head": "drawer-module-scss-module__nzOrvG__head",
  "item": "drawer-module-scss-module__nzOrvG__item",
  "items": "drawer-module-scss-module__nzOrvG__items",
  "link": "drawer-module-scss-module__nzOrvG__link",
  "table": "drawer-module-scss-module__nzOrvG__table",
  "title": "drawer-module-scss-module__nzOrvG__title",
  "variant": "drawer-module-scss-module__nzOrvG__variant",
  "variants": "drawer-module-scss-module__nzOrvG__variants",
  "visible": "drawer-module-scss-module__nzOrvG__visible",
});
